import { render, staticRenderFns } from "./UserAccountRequest.vue?vue&type=template&id=4833b9cb&scoped=true"
import script from "./UserAccountRequest.vue?vue&type=script&lang=js"
export * from "./UserAccountRequest.vue?vue&type=script&lang=js"
import style0 from "./UserAccountRequest.vue?vue&type=style&index=0&id=4833b9cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4833b9cb",
  null
  
)

export default component.exports